// const BaseUrl = 'http://localhost:5000';
const BaseUrl = 'https://email-sender.de-bugger.in';

const apiEndpoints = {
    login: `${BaseUrl}/api/v1/auth/login`,
    sendMail: `${BaseUrl}/api/v1/ses/send-mail`,
    emailCount: `${BaseUrl}/api/v1/ses/email-count`,
    trustedEntities: `${BaseUrl}/api/v1/ses/trusted-entities`,
    addEmail: `${BaseUrl}/api/v1/ses/add-email`,
};

export { apiEndpoints, BaseUrl };